import { ref, nextTick, getCurrentInstance } from 'vue';
import { useRoute } from '@/utils/vue-api';
import { useModuleData } from '@/view/enterprise_rebuild/hooks/data/useModuleData';

export function useReportFullLogic() {
	const { proxy } = getCurrentInstance();
	const { report_tabs, report_list } = useModuleData();
	const route = useRoute();

	const emptyData = ref(false);
	const tabOption = ref([]);
	const REPORT_RATE = ref([]);
	const activeTab = ref(0);
	const listData = ref([
		{
			list: [],
			pagestart: 0,
			hasMore: true,
			rating: '',
			emptyShow: false
		}
	]);
	const initialLoading = ref(true);

	async function initializeData() {
		await report_tabs.refresh();

		if (report_tabs.error || !report_tabs.data?.data) {
			emptyData.value = true;
			return;
		}

		tabOption.value = (report_tabs.data?.data || [])
			.sort((a, b) => a.sort - b.sort)
			.filter(v => v.isPublish)
			.map(v => {
				REPORT_RATE.value.push(v);
				return v.name;
			});

		const { active } = route.query;
		if (active) {
			const findTabIndex = REPORT_RATE.value.findIndex(v => v.value == active);
			if (findTabIndex != -1) {
				activeTab.value = findTabIndex;
			}
		}

		initList();
		loadData();
	}

	function changeActive(idx) {
		if (report_list.loading) return;
		activeTab.value = idx;

		if (listData.value[idx].list.length == 0 && listData.value[idx].hasMore) {
			loadData(true);
		}
	}

	function initList() {
		if (tabOption.value.length) {
			const newListData = REPORT_RATE.value.map(item => {
				const currId = item.value;
				const currTabIds = [currId, ...(item.subTabList || []).map(sub => sub.value)].map(v => Number(v));
				return {
					list: [],
					pagestart: 0,
					hasMore: true,
					rating: !currId ? '' : currTabIds,
					emptyShow: false
				};
			});
			proxy.$set(listData, 'value', newListData);
		} else {
			const newListData = [
				{
					list: [],
					pagestart: 0,
					hasMore: true,
					rating: '',
					emptyShow: false
				}
			];
			proxy.$set(listData, 'value', newListData);
		}
	}

	async function loadData(reload = false) {
		let target = listData.value[activeTab.value];

		if (!target) {
			console.warn('Target data not found for activeTab:', activeTab.value);
			return;
		}

		await report_list.refresh({
			pagestart: target.pagestart,
			pagenum: 20,
			rating: target.rating
		});

		const result = report_list.data?.rows || [];
		const total = report_list.data?.total || 0;

		const updatedTarget = {
			...target,
			list: reload ? result : [...target.list, ...result],
			hasMore: (reload ? result.length : target.list.length + result.length) < total,
			emptyShow: !total
		};

		proxy.$set(listData.value, activeTab.value, updatedTarget);
		await nextTick();
	}

	async function scrollPullDown(done) {
		setPageStart('pullDown');
		await loadData(true);
		done();
	}

	async function scrollPullUp(done) {
		if (report_list.loading) return;
		setPageStart('pullUp');
		await loadData();
		done();
	}

	function setPageStart(type) {
		let _activeTab = activeTab.value;
		let target = listData.value[_activeTab];

		if (!target) {
			console.warn('Target data not found for activeTab:', _activeTab);
			return;
		}

		const updatedTarget = {
			...target,
			pagestart: type == 'pullDown' ? 0 : target.pagestart + 1
		};

		proxy.$set(listData.value, _activeTab, updatedTarget);
	}

	return {
		emptyData,
		tabOption,
		activeTab,
		listData,
		initialLoading,
		initializeData,
		changeActive,
		scrollPullDown,
		scrollPullUp
	};
}
